var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.draggable,
    _vm._b(
      {
        staticClass: "pb-1",
        attrs: {
          list: _setup.treeItems,
          group: {
            name: "layers-tree",
            pull: true,
          },
          move: _setup.handleMove,
        },
        on: { change: _setup.onChange },
      },
      "draggable",
      _setup.dragOptions,
      false
    ),
    [
      _setup.treeItems && _setup.treeItems.length
        ? _vm._l(_setup.treeItems, function (treeItem, index) {
            return _c(
              _setup.CLazy,
              { key: _setup.getItemKey(treeItem) },
              [
                _c(_setup.LayersTreeItem, {
                  on: { "tree-item-moved": _setup.layerTreeItemMove },
                  model: {
                    value: _setup.treeItems[index],
                    callback: function ($$v) {
                      _vm.$set(_setup.treeItems, index, $$v)
                    },
                    expression: "treeItems[index]",
                  },
                }),
              ],
              1
            )
          })
        : [
            _c("div", { staticClass: "no-children" }, [
              _vm._v("This is empty"),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }